var map = {
	"./aussierules.png": 1642,
	"./baseball.png": 1643,
	"./basketball.png": 1644,
	"./boxing.png": 1645,
	"./cricket.png": 1646,
	"./darts.png": 1647,
	"./e-sports.png": 1648,
	"./football.png": 1649,
	"./golf.png": 1650,
	"./hockey.png": 1651,
	"./mma.png": 1652,
	"./pool.png": 1653,
	"./racing.png": 1654,
	"./soccer.png": 1655,
	"./tennis.png": 1656,
	"./volleyball.png": 1657
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 688;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/categories ^\.\/.*\.png$
// module id = 688
// module chunks = 0